/**
 * CCSF landing hero slides.
 * Licensed iStock files are optional: drop the listed filenames into
 * src/assets/ccsf/ and they will be used automatically.
 */

export interface CcsfHeroPhoto {
  webpSrcSet: string;
  jpegSrcSet: string;
  jpegSrc: string;
  objectPosition: string;
}

export interface CcsfHeroSlide {
  id: string;
  story: string;
  photo?: CcsfHeroPhoto;
  pendingNote?: string;
}

const unsplashPhoto = (slug: string, objectPosition: string): CcsfHeroPhoto => ({
  webpSrcSet: [
    `/assets/ccsf/${slug}-800w.webp 800w`,
    `/assets/ccsf/${slug}-1280w.webp 1280w`,
    `/assets/ccsf/${slug}-1920w.webp 1920w`
  ].join(', '),
  jpegSrcSet: [
    `/assets/ccsf/${slug}-800w.jpg 800w`,
    `/assets/ccsf/${slug}-1280w.jpg 1280w`,
    `/assets/ccsf/${slug}-1920w.jpg 1920w`
  ].join(', '),
  jpegSrc: `/assets/ccsf/${slug}-1280w.jpg`,
  objectPosition
});

export const CCSF_HERO_SLIDES: CcsfHeroSlide[] = [
  {
    id: 'employee-field-team',
    story: 'SF Environment colleagues taking climate action together',
    // Bias left so narrow/mobile crops keep the smiling colleague in frame
    // instead of the empty gap / pen between people at center.
    photo: unsplashPhoto('sf-employee-field-team', '28% 38%')
  },
  {
    id: 'employee-outreach',
    story: 'SF Environment staff at community sustainability outreach',
    photo: unsplashPhoto('sf-employee-outreach', 'center 42%')
  },
  {
    id: 'employee-bike-to-work',
    story: 'City employees on Bike to Work Day',
    photo: unsplashPhoto('sf-employee-bike-to-work', 'center 48%')
  },
  {
    id: 'cable-cars',
    story: 'San Francisco / city identity / public transportation',
    photo: unsplashPhoto('sf-cable-cars-ragnar-vorel', 'center 42%')
  }
];

export const CCSF_HERO_INTERVAL_MS = 7000;
export const CCSF_HERO_SIZES = '100vw';
